import { render, staticRenderFns } from "./UserReceiveCard.vue?vue&type=template&id=f6d43a7a&scoped=true&"
import script from "./UserReceiveCard.vue?vue&type=script&lang=js&"
export * from "./UserReceiveCard.vue?vue&type=script&lang=js&"
import style0 from "./UserReceiveCard.vue?vue&type=style&index=0&id=f6d43a7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d43a7a",
  null
  
)

export default component.exports